<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4" lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Cifrado presupuestario asignado
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ dataCifrado.cifrado || '-' }}</p>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4"  lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Rubro presupuestario asignado
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ rubroFormateado }}</p>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4" lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Cuenta presupuestaria asignada
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ cuentaFormateada }}</p>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4" lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Especifico de gasto asignado
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ especificoFormateado }}</p>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4" lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Monto total
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ fondoTotalFormateado }}</p>
        </div>
      </v-col>
      <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : 12" sm="6" md="4" lg="3" class="flex-grow-1">
        <div class="titulo-container">
          <p class="font-weight-medium mb-1 primary--text">
            Partida
          </p>
        </div>

        <div class="descripcion-container">
          <p class="mb-0" style="color: #c1c2ca;">{{ dataCifrado.partida || '-' }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    dataCifrado: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rubroFormateado() {
      return this.formatearPrimeraMayuscula(this.dataCifrado?.rubro)
    },
    cuentaFormateada() {
      return this.formatearPrimeraMayuscula(this.dataCifrado?.cuenta)
    },
    especificoFormateado() {
      return this.formatearPrimeraMayuscula(this.dataCifrado?.especifico)
    },
    fondoTotalFormateado() {
      const saldoDisponible = this.dataCifrado?.monto
      if (
        saldoDisponible === null ||
        saldoDisponible === undefined ||
        saldoDisponible === ''
      ) {
        return '-'
      }
      const parsed = Number(saldoDisponible)
      if (Number.isNaN(parsed)) {
        return '-'
      }
      return `$${new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(parsed)}`
    },
  },
  methods: {
    formatearPrimeraMayuscula(value) {
      if (value === null || value === undefined || value === '') {
        return '-'
      }

      const texto = String(value).trim().toLowerCase()
      if (!texto) {
        return '-'
      }

      return texto.charAt(0).toUpperCase() + texto.slice(1)
    },
  }
}
</script>

<style scoped>
.titulo-container {
  height: 48px;
  display: flex;
  align-items: flex-end;
}

.descripcion-container {
  display: flex;
  align-items: flex-start;
}
</style>
